import type { Intersection } from "three";
import type { PointerGesturePressDetail } from "../../../input/PointerGestureInterpreter";
import type { SugarModel } from "../../../loader/SugarModel";
import type { DesignerTransformer } from "../../../core/drag/DesignerTransformer";
import type { DesignerMoveSession, DesignerObject } from "./DesignerObject";
import type { XzPoint } from "../../../shape/segment/types";
import {
  resolveProductProductSnap,
  type MeasurementSnap,
} from "../measure/MeasurementSnapResolver";

export class ProductDesignerObject implements DesignerObject {
  readonly id: string;

  constructor(
    readonly model: SugarModel,
    private readonly _sourceModel: SugarModel,
    private readonly _hit: Intersection,
    private readonly _intersections: Intersection[],
    private readonly _transformer: DesignerTransformer,
    private readonly _delete: (model: SugarModel) => boolean,
  ) {
    this.id = `product:${model.uuid}`;
  }

  select(detail?: PointerGesturePressDetail): void {
    if (!detail) return;
    this._transformer.applyProductSelection(
      { ...detail, isDoubleClick: false },
      this.model,
      this._sourceModel,
      this._intersections,
    );
  }

  unselect(): void {
    this._transformer.clearSelection();
  }

  setHovered(active: boolean): void {
    this._transformer.setProductHover(active);
  }

  beginMove(detail: PointerGesturePressDetail): DesignerMoveSession | null {
    return this._transformer.beginProductMove(
      detail,
      this.model,
      this._sourceModel,
      this._hit,
      this._intersections,
    );
  }

  delete(): boolean {
    this._transformer.clearSelection();
    return this._delete(this.model);
  }

  measurementSnap(source: SugarModel, pointer: XzPoint): MeasurementSnap | null {
    return source === this.model
      ? null
      : resolveProductProductSnap(source, this.model, pointer);
  }
}
